import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { AppEnvironmentConfig } from '@solvace/config/model/environment.config.model';
import { SvcHttpClient } from '@solvace/common/classes/svc-http-client';
import { SvcAppSettings } from '@solvace/common/settings/svc-app-settings';
import { UserService } from '@solvace/core/features/user/services/user.service';

@Injectable()
export class SvcFormCustomFieldHttpClient extends SvcHttpClient {
  private _userService: UserService = inject(UserService);
  private _appSettings: SvcAppSettings = inject(SvcAppSettings);

  public get siteId(): number {
    return this._userService.user.lastSiteId;
  }

  public applicationId: string = this._appSettings.applicationId;

  constructor(
    protected appConfig: AppEnvironmentConfig,
    protected httpClient: HttpClient
  ) {
    super(appConfig.APIs.apiUrlCustomField, httpClient);
  }
}
